/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:16:57
*/


const isUserLoggedInReducer = (state = false, action) => {
	if(action.type === 'SET_LOGGED_IN_TRUE') {
		return true
	} else if(action.type === 'SET_LOGGED_IN_FALSE') {
		return false
	} else {
		return state
	}
}

export default isUserLoggedInReducer;
